import React, { useEffect, useState } from 'react';
import './Modal.css';
import SeparationLine from '../SeparationLine/Separation';
import { AlarmsTable } from './AlarmsTable';
import AlarmForm from './AlarmForm';
import { toast } from 'react-toastify';
import { AlarmsTableMobile } from './AlarmTableMobile';
import AlarmFormMobile from './AlarmFormMobile';

const AlarmsData = [{ "id": "1", "severity": "critical", "alarmName": "LastCommunication", "dataPoint": "Last Comm", "condition": ">", "value": "10 minutes", "status": "Enabled" },
{ "id": "2", "severity": "high", "alarmName": "LowBattery", "dataPoint": "Last Comm", "condition": ">", "value": "20 minutes", "status": "Disabled" },
{ "id": "3", "severity": "medium", "alarmName": "HighGasRate", "dataPoint": "Last Comm", "condition": ">", "value": "15 minutes", "status": "Enabled" },
{ "id": "4", "severity": "low", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "12 minutes", "status": "Enabled" },
{ "id": "4", "severity": "critical", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "5 minutes", "status": "Enabled" },
{ "id": "4", "severity": "critical", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "5 minutes", "status": "Enabled" },
{ "id": "4", "severity": "critical", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "5 minutes", "status": "Enabled" },
{ "id": "4", "severity": "critical", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "5 minutes", "status": "Enabled" },
{ "id": "4", "severity": "critical", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "5 minutes", "status": "Enabled" },
{ "id": "4", "severity": "critical", "alarmName": "High Line Temperature", "dataPoint": "Last Comm", "condition": ">", "value": "5 minutes", "status": "Enabled" },
]
interface Alarm {
    id: number;
    severity: string;
    alarmName: string;
    dataPoint: string;
    condition: string;
    value: string;
    status: string;
}

const intialAlarmValue = {
    id: 0,
    severity: "",
    alarmName: "",
    dataPoint: "",
    condition: "",
    value: "",
    status: "Disabled",
}



const AlarmsModal = ({ isOpen, onClose, title, onCancel }) => {
    const [selectedRow, setSelectedRow] = useState(null); // This will hold the selected row data
    const [isEditSelected, setIsEditSelected] = useState(false)
    const [newAlarm, setNewAlarm] = useState(intialAlarmValue)
    const [isEnabled, setIsEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 620);
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 620 && window.innerWidth <= 1240);

    const handleEditClick = (rowData) => {
        setNewAlarm(rowData); // Set the selected row data to state when edit is clicked
        setIsEditSelected(true)
        setIsEnabled(rowData?.status?.toLocaleLowerCase() === "enabled")
    };

    const handleAlarmValueChange = (key, value) => {
        if (key === "reset") {
            setNewAlarm(intialAlarmValue);
            setIsEnabled(false)
            setIsEditSelected(false)
        } else {
            setNewAlarm((prev) => ({ ...prev, [key]: value }));
        }
    };

    // Function to display toast message
    const addSucessShowToast = () => {
        toast.success('Add Alarm command executed succesfully!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "white", // Text color
                background: "green", // Background color for success messages
            }
        });
    }

    // Function to display toast message
    const updateSucessShowToast = () => {
        toast.success('Update Alarm command executed succesfully!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "white", // Text color
                background: "green", // Background color for success messages
            }
        });
    }


    // Function to display toast message
    const errorShowToast = () => {
        toast.error('Alarm command failed!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "red", // Set your desired text color for error messages
                background: "#f8d7da", // Set your desired background color for error messages
            }
        });
    }

    useEffect(() => {
        let timeoutId;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                const width = window.innerWidth;
                setIsMobile(width < 620); // Width less than 620px is considered mobile
                setIsTablet(width >= 620 && width <= 1024); // Width between 620px and 1024px is considered tablet
            }, 100); // Debounce to prevent excessive state updates
        };

        handleResize(); // Set initial state
        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup on unmount
        };
    }, []);


    useEffect(() => {
        setIsEditSelected(false)
        setNewAlarm(intialAlarmValue)
        setIsEnabled(false)
        setIsLoading(false)
    }, [isOpen])

    const addNewAlarm = async () => {
        setIsLoading(true)
        setTimeout(() => {
            addSucessShowToast()
            setNewAlarm(intialAlarmValue)
            setIsEnabled(false)
            setIsLoading(false)
        }, 3000)
    }

    const updateAlarm = async () => {
        setIsLoading(true)
        setTimeout(() => {
            updateSucessShowToast()
            setNewAlarm(intialAlarmValue)
            setIsEnabled(false)
            setIsLoading(false)
        }, 3000)
        // setIsEditSelected(false)
    }

    return (
        <div
            className={`modal-overlay ${isOpen ? 'open' : ''}`}
            onClick={onClose}
        >
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
            >
                {/* Header with Title and Close Button */}
                <div className="modal-header">
                    <h2 className="modal-title">{title}</h2>
                    <button className="modal-close-button" onClick={() => {
                        onClose()
                        setIsEditSelected(false)
                        setNewAlarm(intialAlarmValue);
                        setIsLoading(false)
                    }}>
                        &times;
                    </button>
                </div>
                <SeparationLine />

                {/* Modal Content: Left and Right Sections */}
                <div className="modal-body">
                    <div className="modal-left-section">
                        {isTablet || isMobile ? <AlarmsTableMobile data={AlarmsData} handleEditClick={handleEditClick} /> : <AlarmsTable data={AlarmsData} handleEditClick={handleEditClick} />}
                    </div>
                    <div className="modal-right-section">
                        {isTablet || isMobile ? <AlarmFormMobile isEditSelected={isEditSelected} addNewAlarm={addNewAlarm} updateAlarm={updateAlarm} newAlarm={newAlarm} handleAlarmValueChange={handleAlarmValueChange} isEnabled={isEnabled} setIsEnabled={setIsEnabled} isLoading={isLoading} /> : <AlarmForm isEditSelected={isEditSelected} addNewAlarm={addNewAlarm} updateAlarm={updateAlarm} newAlarm={newAlarm} handleAlarmValueChange={handleAlarmValueChange} isEnabled={isEnabled} setIsEnabled={setIsEnabled} isLoading={isLoading} />}
                    </div>
                </div>


                {/* Footer with Cancel Button */}
                {!(isMobile || isTablet) ?
                    <>
                        <SeparationLine />
                        <div className="modal-footer">
                            <button className="modal-cancel-button" onClick={() => {
                                onClose()
                                setIsEditSelected(false)
                                setNewAlarm(intialAlarmValue);
                                setIsLoading(false)
                            }}>
                                Cancel
                            </button>
                        </div>
                    </> : <></>
                }
            </div>
        </div>
    );
};

export default AlarmsModal;
